import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import RoleRow from './RoleRow';
import { Admin } from '../types';

interface Props {
  data: Admin[];
  loadMore: () => void;
  hasMore: boolean;
  setUserData: (admin: Admin) => void;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const colWidths = [
  'min-w-[56px]',
  'min-w-[160px]',
  'min-w-[150px]',
  'min-w-[220px]',
  'min-w-[120px]',
  'min-w-[100px]',
];

const headers = ['Name', 'Email', 'Role', 'Last Activity', 'Access', 'Action'];

const RoleTable: React.FC<Props> = ({
  data,
  loadMore,
  hasMore,
  setUserData,
  setIsOpen,
}) => (
  <div className='relative h-full'>
    <div
      id='gamic-scroll'
      className='absolute inset-0 scrollbar scrollbar-thumb-[#EEEEEE] scrollbar-track-transparent overflow-auto'
    >
      <InfiniteScroll
        dataLength={data.length}
        next={loadMore}
        hasMore={hasMore}
        loader={<div className='p-4 text-center text-sm'>Loading…</div>}
        scrollableTarget='gamic-scroll'
        className='!overflow-visible'
      >
        <table className='min-w-full  table-fixed text-left'>
          <colgroup>
            {colWidths.map((w, i) => (
              <col key={i} className={w} />
            ))}
          </colgroup>
          <thead className='sticky top-0 z-10 bg-white border-b'>
            <tr>
              {headers.map((h, i) => (
                <th
                  key={i}
                  className={`px-4 py-[18px] font-bold whitespace-nowrap ${i === headers.length - 1 ? 'pr-[21px]' : ''}`}
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((g) => (
              <RoleRow
                key={g.id}
                admin={g}
                setIsOpen={setIsOpen}
                setUserData={setUserData}
              />
            ))}
          </tbody>
        </table>
      </InfiniteScroll>
    </div>
  </div>
);

export default RoleTable;
